import { NgModule } from '@angular/core';
import { PriceModule } from '@icc/price';
import { PriceGarageService } from './price-garage.service';

@NgModule({
    imports: [PriceModule],
    providers: [PriceGarageService],
})
export class GarageDoorPriceModule {}
